/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/


export enum ConfiguratorLayoutEnum {
    "retail" = "retail",
    "wholesale" = "wholesale"
}

export type ConfiguratorLayout = ConfiguratorLayoutEnum;